import React from 'react';
import { Button, Container, Paper, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';
import { useMutation } from 'react-query';
import API, { useCsrfToken } from '@wheeebo/polaris-api';
import { useSnackbar } from '@wheeebo/polaris-snackbar';
import { useErrorHandler } from '../errorHandler';
import { CircleLoader } from '../loader';
const msgs = defineMessages({
    headerTitle: {
        id: 'pages.guest.EmailVerifyPage.header.title',
        defaultMessage: 'Email Verification',
    },
    buttonBackToLoginPage: {
        id: 'pages.guest.EmailVerifyPage.button.backToLoginPage',
        defaultMessage: 'Back to the login page',
    },
    textVerified: {
        id: 'pages.guest.EmailVerifyPage.text.verified',
        defaultMessage: 'Your email was successfully verified. Please sign in at the login page',
    },
    textVerificationFailed: {
        id: 'pages.guest.EmailVerifyPage.text.verificationFailed',
        defaultMessage: 'The verification failed.',
    },
});
function EmailVerifyPage() {
    const intl = useIntl();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { showAndEmitJsErrorEvent } = useErrorHandler();
    const { showSuccess } = useSnackbar();
    const { csrfToken } = useCsrfToken();
    const handleGoBack = () => navigate('/');
    const mid = searchParams.get('mid') ?? '';
    const emailToken = searchParams.get('token') ?? '';
    const { mutate, isLoading, isSuccess, isError } = useMutation((props) => API.Accounts.verifyEmail(csrfToken, props.memberId, props.token), {
        onSuccess: () => {
            showSuccess('Email verified');
            setTimeout(() => navigate('/'), 1000);
        },
        onError: showAndEmitJsErrorEvent,
    });
    React.useEffect(() => {
        if (!mid || !emailToken || !csrfToken) {
            return;
        }
        mutate({ memberId: mid, token: emailToken });
    }, [mid, emailToken, csrfToken, mutate]);
    return (React.createElement(Container, { component: "main", sx: { display: 'flex', justifyContent: 'center' } },
        React.createElement(Paper, { sx: { width: 400, mt: 8, p: 3 } },
            React.createElement(Stack, { gap: 3 },
                React.createElement(Typography, { variant: "h6", align: "center" }, intl.formatMessage(msgs.headerTitle)),
                isLoading ? React.createElement(CircleLoader, null) : null,
                isSuccess ? React.createElement(Typography, { variant: "body1" }, intl.formatMessage(msgs.textVerified)) : null,
                isError ? React.createElement(Typography, { variant: "body1" }, intl.formatMessage(msgs.textVerificationFailed)) : null,
                React.createElement(Button, { onClick: handleGoBack, startIcon: React.createElement(ArrowBackIcon, null), size: "medium" }, intl.formatMessage(msgs.buttonBackToLoginPage))))));
}
export default React.memo(EmailVerifyPage);
